// extracted by mini-css-extract-plugin
module.exports = {"box":"nvzBPEdZvP","visible":"_2OHo4xQ6k_","micro":"_3WjRY2y7pq","inline":"_1uPePYhgrG","spinner":"_1fUdjhEh_4","bar":"_3MWkqfxLmh","circle":"_1_nMwMntwl","rotate":"UfbaSFMH6o","stop":"_30tsqsOKdj","faded":"T0fZuSOklu","message":"_3QfnvM1id2","center":"_2CkAh579Pb","small":"DoHsi8W2sE"};
    if(module.hot) {
      // 1614934675824
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  